<!-- 设备管理-设备列表页面 -->
<template>
  <div class="vcnDeviceList">
    <!--主页面 -->
    <div class="flex-row" style="height: 100%">
      <!-- 左侧树 -->
      <div class="section-mian_left tree-line-style">
        <div class="left_title">设备信息</div>
        <div class="device-tab">
          <div v-for="item in calType.column" :key="item.typeId" :class="['tab', type.prop == item.prop ? 'active' : '']"
            @click="handleChange(item)">
            {{ item.label }}
          </div>
        </div>
        <div v-if="type.prop === 'tab1'" class="left-type_area"></div>
        <div v-show="type.prop === 'tab2'" class="left-type_area sbar">
          <div class="device-search">
            <el-input placeholder="请输入搜索关键字" prefix-icon="el-icon-search" v-model="searchString" clearable>
            </el-input>
          </div>
          <el-scrollbar class="flex-auto" style="height: calc(100% - 50px)">
            <el-tree ref="tree" class="mb20" node-key="areaDevGroupCode" :data="areaTreeData" :highlight-current="true"
              :default-expand-all="true" :props="defaultProps" :filter-node-method="filterNode"
              @node-click="handleNodeClick">
              <template slot-scope="{ node }">
                <element-tree-line :node="node" :showLabelLine="true" :indent="16" class="tree-line">
                  <span class="custom-tree-node" style="display: block">
                    <i class="el-icon-document"></i>
                    <span class="node-label" style="margin-left: 3px" :title="node.label">{{ node.label }}</span>
                  </span>
                </element-tree-line>
              </template>
            </el-tree>
          </el-scrollbar>
        </div>
      </div>

      <!-- 右侧表单 -->
      <div class="section-mian_right">
        <!-- 头部按钮 -->
        <div class="section-mian__toolbar flex-row">
          <el-button type="primary" class="iss-operation-button" icon="iconfont icon-iconfontfanhui" @click="retBtn">{{
            $t("cameraList.button.back") }}</el-button>
        </div>
        <!-- 右侧表格 -->
        <div class="section-main_table">
          <ioc-table ref="devTab" :data="tableData" :option="otherOption" :page="page" @current-change="selectPage"
            @selection-change="selectionChange" @size-change="changeSize" @search-change="seaByArea"
            @search-reset="emptyAreaData">
            <template slot="menuLeft">
              <el-button type="primary" size="small" class="iss-operation-button" icon="el-icon-plus"
                @click="handleAddShow">
                新增设备
              </el-button>
            </template>
            <template slot="menu" slot-scope="scope">
              <el-tooltip class="item" effect="dark" content="修改" placement="top" popper-class="tooltip-draw">
                <i class="el-icon-edit-outline" @click="handleUpdate(scope.row, scope.index)"
                  style="font-size: 16px; color: #407AEE; cursor: pointer; margin: 0 10px;"></i>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" content="删除" placement="top" popper-class="tooltip-draw">
                <i class="el-icon-delete" @click="handleDel(scope.row, scope.index)"
                  style="font-size: 16px; color: #407AEE; cursor: pointer; margin: 0 10px;"></i>
              </el-tooltip>
            </template>
          </ioc-table>
        </div>
      </div>
    </div>
    <el-dialog :title="operateTitle" :visible.sync="addVisible" append-to-body :close-on-click-modal="modalClose"
      width="32%" style="margin-top: 10vh;" :validate-on-rule-change="ruleChange">
      <el-form :model="addForm" ref="addForm" :rules="addRules" label-width="120px">
        <el-form-item label="设备名称" prop="thirdDeviceName">
          <el-input v-model="addForm.thirdDeviceName" placeholder="请输入设备名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="描述" prop="thirdDeviceDesc">
          <el-input v-model="addForm.thirdDeviceDesc" placeholder="请输入描述" type="textarea" :rows="3" clearable></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addConfirm('addForm')">确 定</el-button>
        <el-button @click="addCancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import ElementTreeLine from "element-tree-line";
import { api } from "../api";
import utils from "@src/common/utils";
import { Dic, Cache } from "$utils";
import { otherTableOption } from "../const/otherTable";
export default {
  components: {
    ElementTreeLine
  },
  watch: {
    searchString(val) {
      this.$refs.tree.filter(val);
    },
  },
  data() {
    return {
      searchString: "",
      clickSearch: false,
      selectedAreaNode: "",
      currentRow: {},
      deviceTreeShow: false,
      // 提示框内容
      tipData: "",
      // 选中的设备ID
      selDev: [],
      selThirdDev: [],
      selectedDevs: [],
      devInfoDialog: false,
      editDevDialog: false,
      // 选中左侧列表选项的下标
      activeState: Number,
      // 设备类型划分查询条件
      devTyName: "",
      devTyId: "",
      changeAttr: false,
      // 区域划分查询条件
      devAreaManu: "",
      devAreaName: "",
      // 控制仅显示无区域设备
      checked: false,
      checkedDevice: false,
      isMap: false,
      // 按照区域划分时搜索条件设备类型绑定对象
      serDevTyOption: [],
      // 按照区域划分时搜索条件厂家绑定对象
      serManOption: [],
      // 控制头部功能按钮显隐
      accType: true,
      accReg: false,
      // 控制头部搜索条件变更
      devTypeSer: true,
      devAreaSer: false,
      //摄像机分类方式
      type: {},
      calType: {
        column: [
          {
            label: this.$t("cameraList.label.deviceSet"),
            prop: "tab1",
          },
          {
            label: this.$t("cameraList.label.areaSets"),
            prop: "tab2",
          },
        ],
      },
      // 区域树对象
      areaTreeData: [],
      // 设备组树对象
      deviceTreeData: [],
      defaultProps: {
        children: "areaChildren",
        label: "areaDevGroupName",
      },
      deviceDefaultProps: {
        children: "children",
        label: "name",
        isLeaf: "isLeaf",
      },
      otherOption: otherTableOption(true, false),
      tableData: [],
      // 分页属性设置
      page: {
        currentPage: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      // 请求设备列表的数据对象
      getDevPra: {},
      // 判断是否勾选查询无区域
      isArea: "",
      // 判断是否勾选查询无设备组
      isDeviceWorkGroup: "",
      areaDevGroupCode: "",
      selectedDeviceNode: "",
      // 左侧列表设备类型选中值
      checkDevType: "",
      deviceWorkGroupCode: "",
      paramsType: "",
      addVisible: false,
      modalClose: false,
      ruleChange: false,
      addRules: {
        thirdDeviceName: [{ required: true, message: '请输入设备名称', trigger: 'change' }]
      },
      addForm: {
        deviceID: null,
        thirdDeviceName: null,
        thirdDeviceDesc: null
      },
      operateTitle: '新增设备'
    };
  },
  created() {
    // 请求全量数据
    this.initGet();
    this.setCheckDevType();
    this.getAreaTree();
    // 默认进入页面选中第一种分类方式
    if (this.checkDevType === "18") {
      this.calType = {
        column: [
          {
            label: this.$t("cameraList.label.deviceSet"),
            prop: "tab1",
          },
          {
            label: this.$t("cameraList.label.areaSets"),
            prop: "tab2",
          },
        ],
      };
    } else if (this.checkDevType === "26") {
      // 广播
      this.calType = {
        column: [
          {
            label: this.$t("cameraList.label.deviceSet"),
            prop: "tab1",
          },
          {
            label: this.$t("cameraList.label.areaSets"),
            prop: "tab2",
          },
        ],
      };
    } else {
      this.calType = {
        column: [
          {
            label: this.$t("cameraList.label.areaSets"),
            prop: "tab2",
          },
        ],
      };
      this.handleChange({
        label: this.$t("cameraList.label.areaSets"),
        prop: "tab2",
      });
    }
    this.type = this.calType.column[0];
  },
  mounted() { },
  destroyed() {
    Cache.remove("deviceTypeName");
    Cache.remove("deviceTypeId");
  },
  methods: {
    handleAddShow() {
      this.operateTitle = "新增设备"
      this.addForm.deviceID = null
      this.addForm.thirdDeviceName = null
      this.addForm.thirdDeviceDesc = null
      this.addVisible = true
    },
    addConfirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.addForm.deviceID) {
            let params = {
              areaDevGroupCode: this.areaDevGroupCode,
              deviceID: this.addForm.deviceID,
              thirdDeviceName: this.addForm.thirdDeviceName,
              thirdDeviceDesc: this.addForm.thirdDeviceDesc
            }
            this.$fetch('/cms/accessportal/updateOtherDevice.json', params).then((response) => {
              if (response.success) {
                this.$message.success(response.msgContent)
                this.addVisible = false
                this.getDevList()
              } else {
                this.$message.error(response.msgContent);
              }
            });
          } else {
            let params = {
              areaDevGroupCode: this.areaDevGroupCode,
              thirdDeviceName: this.addForm.thirdDeviceName,
              thirdDeviceDesc: this.addForm.thirdDeviceDesc
            }
            this.$fetch('/cms/accessportal/addOtherDevice.json', params).then((response) => {
              if (response.success) {
                this.$message.success(response.msgContent)
                this.addVisible = false
                this.getDevList()
              } else {
                this.$message.error(response.msgContent);
              }
            });
          }
        }
      })
    },
    addCancel() {
      this.addVisible = false
    },
    handleUpdate(row) {
      this.operateTitle = "修改设备"
      this.addForm.deviceID = row.deviceId
      this.addForm.thirdDeviceName = row.thirdDeviceName
      this.addForm.thirdDeviceDesc = row.deviceDescription
      this.addVisible = true
    },
    handleDel(row) {
      const params = {
        deviceIDList: [row.deviceId]
      };
      this.$confirm("您确定要删除此条数据吗?", "删除确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$fetch('/cms/accessportal/deleteDevice.json', params).then((response) => {
          if (response && response.success) {
            this.$message({
              message: "删除成功",
              type: "success",
              duration: 2000,
            });
          } else {
            this.$message({
              message: "删除失败",
              type: "error",
              duration: 2000,
            });
          }
          this.getDevList()
        });
      });
    },
    filterNode(value, data) {
      if (!value) {
        return true;
      }
      return data.areaDevGroupName.indexOf(value) !== -1;
    },
    // 请求设备列表
    getDevList() {
      this.tableData = [];
      const loading = this.$loading({
        lock: true,
        text: "请求中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$fetch(api.deviceMan.getDeviceListByPage, this.getDevPra).then((res) => {
        setTimeout(() => {
          loading.close();
        }, 500);
        if (res.success) {
          this.otherOption = otherTableOption(this.type.prop === "tab1");
          this.$refs.devTab.selectClear();
          this.tableData = res.returnObj.list;
          this.page.total = res.returnObj.total;
        } else {
          this.$message({
            message: res.msgContent,
            type: "error",
          });
        }
      });
    },
    // 区域树——根据搜索条件搜索设备列表
    seaByArea(param) {
      this.clickSearch = true;
      this.page.currentPage = 1;
      let params = {
        isArea: this.checked === true ? "1" : "",
        area: this.areaDevGroupCode, //区域相关的
        deviceId: "",
        cameraFeature: this.cameraFeature,
        deviceName: this.devAreaName,
        deviceType: this.checkDevType,
        factoryId: this.devAreaManu,
        page: this.page.currentPage,
        pageSize: this.page.pageSize,
        parentCodes: "", //区域相关的，父级code
        status: this.cameraStatus,
        isMap: this.isMap ? "1" : "",
        isDeviceWorkGroup: this.isDeviceWorkGroup,
        ...param,
      };
      this.getDevPra = params;
      this.getDevList();
    },
    getAreaTree() {
      this.$fetch(api.deviceMan.queryAssociationalDeviceTree).then((res) => {
        this.areaTreeData = res.returnObj;
        this.$nextTick(() => {
          this.$refs.tree.setCurrentKey(this.areaTreeData[0]);
        });
      });
    },
    getDeviceTreeData(data) {
      this.deviceTreeData = data;
    },
    // 设备类型查询按钮查询设备列表
    queryDevList() {
      this.page.currentPage = 1;
      let params = {
        deviceId: this.devTyId,
        deviceName: this.devTyName,
        deviceType: this.checkDevType,
        cameraFeature: this.cameraFeature,
        page: this.page.currentPage,
        pageSize: this.page.pageSize,
        status: this.cameraStatus,
        isDeviceWorkGroup: this.isDeviceWorkGroup,
        deviceWorkGroupCode:
          this.deviceWorkGroupCode !== "" ? this.deviceWorkGroupCode : "",
        isMap: this.isMap ? "1" : "",
      };
      this.getDevPra = params;
      this.getDevList();
    },
    // 设备类型重置搜索框内容
    emptyData() {
      this.cameraFeature = "";
      this.cameraStatus = "";
      this.devTyName = "";
      this.devTyId = "";
      this.isDeviceWorkGroup = "";
      this.checkedDevice = false;
      this.page.currentPage = 1;
      this.page.pageSize = 10;
      this.queryDevList();
    },
    // 区域重置搜索框内容
    emptyAreaData() {
      this.devAreaName = "";
      this.devAreaManu = "";
      this.cameraFeature = "";
      this.cameraStatus = "";
      this.checked = false;
      this.clickSearch = false;
      this.isArea = "";
      this.isMap = "";
      this.checkedDevice = "";
      this.page.currentPage = 1;
      this.page.pageSize = 10;
      let params = {
        isArea: this.isArea,
        // area:'', //区域相关的
        // 修改3503问题单
        area: this.areaDevGroupCode,
        deviceId: "",
        cameraFeature: "",
        deviceName: "",
        deviceType: this.checkDevType,
        factoryId: "",
        page: 1,
        pageSize: 10,
        parentCodes: "", //区域相关的，父级code
        status: "",
        isMap: this.isMap ? "1" : "",
      };
      this.getDevPra = params;
      this.getDevList();
    },
    // 选择左侧设备类型查询设备列表
    cheDevTy() {
      this.page.currentPage = 1;
      let params = {
        area: "", //区域相关的
        deviceId: this.devTyId,
        deviceName: this.devTyName,
        deviceType: this.checkDevType,
        page: this.page.currentPage,
        pageSize: this.page.pageSize,
        parentCodes: "", //区域相关的，父级code
        // status: ''
        status: this.cameraStatus,
        isMap: this.isMap ? "1" : "",
      };
      this.getDevPra = params;
      this.getDevList();
      //  this.activeState = index;
    },
    moveInDevice() {
      if (this.type.prop === "tab1") {
        if (this.selectedDeviceNode === "") {
          this.$message.warning("请选择挪入的设备组");
          return;
        }
        let params = {
          operateType: 1,
          deviceWorkGroupCode: this.selectedDeviceNode,
          deviceIdList: this.selDev,
        };
        this.$fetch(api.updateDeviceDeviceWorkGroup, params).then((response) => {
          if (response.success) {
            this.$message({
              message: this.$t("cameraList.message.moveIntoSucc"),
              type: "success",
            });
            this.deviceTreeShow = false;
            // 刷新界面数据
            this.getDevList();
            this.$refs.devTab.selectClear();
          } else {
            this.$message({
              message: response.msgContent,
              type: "warning",
            });
          }
        });
      } else {
        if (this.selectedAreaNode === "") {
          this.$message.warning(this.$t("cameraList.message.chooseEnterArea"));
          return;
        }
        let params = {
          area: this.selectedAreaNode,
          deviceIds: this.selDev,
        };
        this.$fetch(api.deviceMan.updateDeviceArea, params).then((response) => {
          if (response.success) {
            this.$message({
              message: this.$t("cameraList.message.moveIntoSucc"),
              type: "success",
            });
            this.deviceTreeShow = false;
            // 刷新界面数据
            this.getDevList();
            this.$refs.devTab.selectClear();
          } else {
            this.$message({
              message: response.msgContent,
              type: "warning",
            });
          }
        });
      }
    },
    selectAreaNode(data) {
      this.selectedAreaNode = data.areaDevGroupCode;
    },
    selectDeviceNode(data) {
      this.selectedDeviceNode = data.id;
    },
    // 树节点点击事件
    handleNodeClick(data) {
      this.page.currentPage = 1;
      this.areaDevGroupCode = data.areaDevGroupCode;
      this.isArea = "";
      this.checked = false;
      let params = {
        isArea: this.isArea,
        area: this.areaDevGroupCode, //区域相关的
        deviceId: "",
        deviceName: this.devAreaName,
        deviceType: this.checkDevType,
        factoryId: this.devAreaManu,
        page: this.page.currentPage,
        pageSize: this.page.pageSize,
        // parentCodes: this.areaDevGroupCode,  //区域相关的，父级code
        // status: ''
        status: this.cameraStatus,
        isMap: this.isMap ? "1" : "",
      };
      this.getDevPra = params;
      this.getDevList();
    },
    // 编辑框保存按钮
    editDlgPre() {
      let data = {};
      data = this.$refs.editDev.devInData;
      this.$refs.editDev.validateForm().then((valid) => {
        // console.log(data);
        if (valid) {
          let params = {
            // buildingName:"",//建筑物名称
            buildingCode: data.buildingCode, //建筑物id
            abscissa: data.isIndoor == 1 ? data.abscissa : null, //横坐标
            ordinate: data.isIndoor == 1 ? data.ordinate : null, //纵坐标
            width: data.isIndoor == 1 ? data.width : null,
            height: data.isIndoor == 1 ? data.height : null,
            deviceId: data.deviceId, //设备id
            deviceName: data.deviceName, //设备名称
            latitude: data.isIndoor == 0 ? data.latitude : null,
            longitude: data.isIndoor == 0 ? data.longitude : null,
            isIndoor: data.isIndoor, //0 室外，1室内
            deviceDescription: data.deviceDescription, //设备描述
            area: data.areaCode, //区域编码
            buildingId: data.isIndoor == 1 ? data.buildingId : "", //楼栋id
            buildName: data.isIndoor == 1 ? data.buildName : "", //楼栋名称
            floorId: data.isIndoor == 1 ? data.floorId : "", //楼层id
            floorName: data.isIndoor == 1 ? data.floorName : "", //楼层名称

            resolutionWide: data.resolutionWide, //像素宽
            resolutionHigh: data.resolutionHigh, //像素高

            ip: data.ip,
            port: data.port,
            userName: data.userName,
            password: data.password,

            altitude: data.altitude,
            // trafficType: data.trafficType,//通行方式
          };
          // console.log(params, "---params-----");
          this.editLoading = true;
          this.$fetch(api.deviceMan.updateDeviceInfoById, params).then((res) => {
            this.editLoading = false;
            if (res.success === true) {
              this.$message.success(res.msgContent || "操作成功");
              this.$refs.editDev.devInData.resolutionWide = "";
              this.$refs.editDev.devInData.resolutionHigh = "";
              this.editDevDialog = false;
              this.getDevList();
            } else if (res.success === false) {
              this.$message.error(res.msgContent);
            }
          });
        } else {
          return false;
        }
      });
    },
    // 编辑框取消按钮
    editDlgCan() {
      this.$refs.editDev.devInData.resolutionWide = "";
      this.$refs.editDev.devInData.resolutionHigh = "";
      this.editDevDialog = false;
    },
    // 分页事件
    selectPage(val) {
      this.$refs.devTab.selectClear();
      this.page.currentPage = val;
      this.getDevPra.page = val;
      if (!this.clickSearch || !this.isArea) {
        this.getDevPra.isArea = this.isArea = "";
      }
      this.getDevPra.deviceType = this.checkDevType;
      this.getDevList();
    },
    changeSize(val) {
      this.getDevPra.pageSize = val;
      this.getDevPra.page = 1;
      this.getDevPra.deviceType = this.checkDevType;
      if (!this.clickSearch || !this.isArea) {
        this.getDevPra.isArea = this.isArea = "";
      }
      this.page.pageSize = val;
      this.page.currentPage = 1;
      this.getDevList();
    },
    // 切换左侧选项卡
    handleChange(column) {
      this.type = column;
      // 切换选项卡重置所有搜索条件
      this.devAreaName = "";
      this.devAreaManu = "";
      this.devTyName = "";
      this.devTyId = "";
      this.isArea = "";
      this.isDeviceWorkGroup = "";
      this.cameraStatus = "";
      this.cameraFeature = "";
      this.checked = false;
      this.checkedDevice = false;
      this.page.currentPage = 1;
      this.page.pageSize = 10;
      this.deviceTreeShow = false;
      if (this.type.prop === "tab1") {
        this.activeState = Number;
        // 切换头部按钮
        this.accType = true;
        this.accReg = false;
        // 切换表格样式
        this.otherOption = otherTableOption(true, true);
        // 切换头部搜索条件
        this.devTypeSer = true;
        this.devAreaSer = false;
        // 清空请求条件，请求全量数据
        // this.initGet();
      } else if (this.type.prop === "tab2") {
        this.accType = false;
        this.accReg = true;
        this.otherOption = otherTableOption(false, false);
        this.devTypeSer = false;
        this.devAreaSer = true;
        // this.initGet();
      }
      this.$nextTick(() => {
        this.$refs.devTab.reset();
      });
    },
    setCheckDevType() {
      if (this.$route.query.device) {
        const data = JSON.parse(this.$route.query.device)
        this.checkDevType = data.deviceTypeId;
        Cache.put("deviceTypeId", data.deviceTypeId);
        this.paramsType = data.deviceType;
        Cache.put("deviceType", data.deviceType);
      } else {
        // 缓存参数 防止页面属性数据丢失
        this.checkDevType = Cache.get("deviceTypeId");
        this.paramsType = Cache.get("deviceType");
      }
    },
    // 初始化查询条件，查询全量数据；
    initGet() {
      this.setCheckDevType();
      let params = {
        area: "", //区域相关的
        deviceId: "",
        deviceName: "",
        deviceType: this.checkDevType,
        page: this.page.currentPage,
        pageSize: this.page.pageSize,
        parentCodes: "", //区域相关的，父级code
        // status: ''
        status: this.cameraStatus,
        deviceWorkGroupCode:
          this.deviceWorkGroupCode !== "" ? this.deviceWorkGroupCode : "",
        isMap: this.isMap ? "1" : "",
      };
      // console.log('--this.deviceWorkGroupCode-----', this.deviceWorkGroupCode);
      this.getDevPra = params;
      this.getDevList();
    },
    // 勾选事件
    selectionChange(selections) {
      if (selections.length < this.page.pageSize && selections.length > 0) {
        setTimeout(() => {
          $(".el-table__fixed-header-wrapper label.el-checkbox>span").attr(
            "class",
            "el-checkbox__input is-indeterminate"
          );
        }, 200);
      }
      this.selDev = [];
      this.selThirdDev = [];
      this.selectedDevs = selections;
      selections.map((item) => {
        this.selDev.push(item.deviceId);
        this.selThirdDev.push(item.thirdDeviceId);
      });
    },
    retBtn() {
      // this.$router.go(-1);
      this.$router.push("/cameralist/devicelist");
    },
    getDeviceWrokGroupCode(code) {
      this.deviceWorkGroupCode = code;
      this.initGet();
    },
  },
};
</script>
<style lang="scss">
@import "~@src/common/assets/style/mixin";

.node-label {
  // display: inline-block;
  width: 300px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}

.ellipsis {
  width: 225px;
}

.vcnDeviceList {
  width: 100%;
  height: 100%;
  position: relative;

  .left_title {
    border-left: 4px solid #407aee;
    padding-left: 8px;
    margin: 16px;
  }

  .device-tab {
    display: flex;
    margin: 0 16px 0px 16px;

    .tab {
      // color: #9aa6c1;
      flex: 1;
      text-align: center;
      padding-bottom: 10px;
      border-bottom: 1px solid #707070;

      &:hover {
        // color: #fff;
        cursor: pointer;
      }
    }

    .active {
      // color: #fff;
      border-color: #407aee;
    }
  }

  .device-search {
    display: flex;
    margin: 15px 16px;
    height: 28px;

    .el-input {
      width: 100%;
    }
  }

  .devTyList {
    padding: 3px 10px;
    margin: 5px 10px;
    cursor: pointer;
  }

  .devTyListCheck {
    @include set_theme_color(background-color, page-bg-color);
  }

  .left-type_area {
    height: calc(100% - 100px);
    position: relative;
    flex: 1;
    overflow: hidden;
    @include set_theme_color(background-color, left-menu-bg-color);
  }

  .el-dialog__footer {
    // padding: 20px;
    // padding-top: 10px;
    text-align: right;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  .upload-demo {
    margin: 0 10px;
  }

  .el-tabs--bottom .el-tabs__item.is-bottom:nth-child(2),
  .el-tabs--bottom .el-tabs__item.is-top:nth-child(2),
  .el-tabs--top .el-tabs__item.is-bottom:nth-child(2),
  .el-tabs--top .el-tabs__item.is-top:nth-child(2) {
    padding-left: 10px;
  }
}

.el-select {
  width: 100%;
}

.dialog-tree {}

.dialog-bar {
  height: 400px;
  padding-bottom: 16px;
  @include set_theme_color(background-color, left-menu-bg-color);
}
</style>
